<template>
  <div>
    <AuBreadcrumb :parent-name="$t('router.pages.dashboard')" />
    <Form class="referral-block card">
      <template #header>
        {{ $t("profileMenu.referralProgram") }}
      </template>
      <div class="referral-fields">
        <div class="referral-field-wrapper">
          <AuInput
            v-model="referralLink"
            :label="$t('referralProgram.userRefLabel')"
          />

          <AuButton
            icon="copy"
            height="44px"
            bordered
            @click="copyToClipboard"
          />
        </div>
        <!-- <div class="referral-source-field-wrapper">
          <label
            class="label"
            for="refSource"
          >
            {{ $t('referralProgram.refSourceSocialPlaceholder') }}
          </label>
          <AuSelect
            :value="refSource"
            class="type-select"
            :options="refSourceOpt"
            :placeholder="$t('referralProgram.refSourceSocialPlaceholder')"
            @input="v => refSource = v"
          />
        </div> -->
        <div class="referral-source-field-wrapper">
          <AuInput
            v-model="refSource"
            type="Mask"
            :label="$t('referralProgram.refSourceLabel')"
            :placeholder="$t('referralProgram.refSourcePlaceholder')"
            :mask="/^[0xa-zA-Z]+$/i"
          />
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { checkAccess, scope } from "@/help/accessData";
import { mapGetters } from "vuex";
export default {
  name: "ReferralProgram",

  data() {
    return {
      refSource: "",
      refSourceOpt: [
        { display: "Youtube", value: "youtube" },
        { display: "Twitter", value: "twitter" },
        { display: "Facebook", value: "facebook" },
        { display: "Instagram", value: "instagram" },
        { display: "Discord", value: "discord" },
        { display: "Linkedin", value: "linkedin" },
        { display: "VK", value: "vk" },
        { display: "Telegram", value: "telegram" },
        { display: "Dzen", value: "dzen" }
      ]
    };
  },

  computed: {
    ...mapGetters({
      profile: "profile/profile"
    }),

    referralLink() {
      const host = window.location.origin;
      return this.refSource ? `${host}/sign?ur=${this.profile?.refCode}&rs=${this.refSource}` : `${host}/sign?ur=${this.profile?.refCode}`;
    },

    referralEnable() {
      return checkAccess(scope.enableReferralSystem);
    }
  },

  mounted() {
    if (!this.referralEnable) {
      this.$router.push({ name: "base" });
    }
  },

  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.referralLink)
        .then(() => {
          this.$toast.success(this.$t("tokeninfo.copySuccess"));
        })
        .catch(() => {
          this.$toast.error(this.$t("tokeninfo.copyError"));
        });
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  &.referral-block {
    padding: 22px;

    .title {
      font-size: 24px;
      line-height: 1em;
      border-bottom: 1px solid var(--color-70);
      padding-bottom: 15px;
      margin-bottom: 20px;
    }

    .referral-field {
      &s {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
      &-wrapper {
        display: flex;
        gap: 15px;
        align-items: flex-end;
      }
    }
  }
}
.label {
  color: var(--color-50);
  font-size: 14px;
  margin-bottom: 8px;
}
</style>